import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IDeleteState, IResponse } from '../../types'

const sharedApiClient = AdminApiClient.getInstance()

export const fetchDeleteBrand = createAsyncThunk(
  'listBrands/fetchDeleteBrand',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await sharedApiClient.deleteBrand(id)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IDeleteState = {
  isLoading: false,
  response: null,
  error: null
}

const deleteBrandSlice = createSlice({
  name: 'brands/delete',
  initialState,
  reducers: {
    resetDeleteBrand: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchDeleteBrand.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchDeleteBrand.fulfilled, (state, action: PayloadAction<IResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchDeleteBrand.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default deleteBrandSlice.reducer
export const { resetDeleteBrand } = deleteBrandSlice.actions
